export enum FeatureFlags {
  DISABLE_SCORE = "disable-score",
  DISABLE_ANALYTICS = "disable-analytics",
};
